
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Auch vonseiten der Ärzte, die mit den neuen Medikamenten Erfahrungen gesammelt
haben, kam Kritik – aber nicht an den Medikamenten, sondern an den Behörden. Die
Krankenkassen brauchen die neuen Medikamente nur ab mindestens 8 Migränetagen
pro Monat zu vergüten. Das sei Willkür, kritisieren die Ärzte. Ausserdem
verlangt das Bundesamt für Gesundheit, dass die neuen Medikamente spätestens
nach einem Jahr für drei Monate abgesetzt werden, um zu prüfen, ob sie noch
nötig sind. Bis die Behandlung weitergehen könne, würden meist etwa vier Monate
vergehen, während derer die Patienten wieder leiden würden.`}</p>
    <p>{`«Für fast alle Patienten, die gut auf die neuen Behandlungen angesprochen haben,
bedeutet das ‹zurück in die Hölle› für mindestens drei Monate», sagt Reto
Agosti, Chefarzt des Kopfwehzentrums Hirslanden. Überdies habe sich gezeigt,
dass die neuen Medikamente mit zunehmender Dauer – ohne Behandlungsunterbrüche –
immer besser wirken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;